// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__389eh","label":"styles_label__qLTSA"};